/*--------------------------------------------------------------
# Custom scripts for Columns Content Block
--------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
    const cardComplexes = document.querySelectorAll('.card--complex');
    if (cardComplexes.length === 0) return;

    function setTranslateBasedOnCardBody() {
        if (window.innerWidth < 992) {
            cardComplexes.forEach(card => {
                const heading = card.querySelector('.wp-block-heading');
                if (heading) heading.style.transform = '';
            });
            return;
        }

        cardComplexes.forEach(card => {
            const cardBody = card.querySelector('.card-body');
            const heading = card.querySelector('.wp-block-heading');

            if (cardBody && heading) {
                const cardBodyHeight = cardBody.offsetHeight;
                const headingHeight = heading.offsetHeight;
                const translateY = cardBodyHeight - headingHeight;

                heading.style.transform = `translate(0, calc(${translateY}px - 14px))`;
            }
        });
    }

    // Run initially
    setTranslateBasedOnCardBody();

    // Run again after short delay (e.g., after animations)
    setTimeout(setTranslateBasedOnCardBody, 210);

    // Throttle on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(setTranslateBasedOnCardBody, 150);
    });

    // ♻️ Add: Rerun transform when a .card--complex is expanded
    cardComplexes.forEach(card => {
        card.addEventListener('transitionend', (e) => {
            if (card.classList.contains('expanded')) {
                setTranslateBasedOnCardBody();
            }
        });

        card.addEventListener('click', () => {
            // Delay to wait for classes to toggle and layout to complete
            setTimeout(() => {
                if (card.classList.contains('expanded')) {
                    setTranslateBasedOnCardBody();
                }
            }, 100);
        });
    });
});

